export default {
    "mapas_grid": {
        "listado_mapas": "Listado de mapas",
        "buscar_mapa": "Buscar mapa...",
        "sin_resultados": "No se ha encontrado ningún mapa",
        "categoria_escenarios": "Escenarios",
        "categoria_otros": "Temáticas",
    },
    "capas_grid": {
        "listado_capas": "Listado de capas",
        "buscar_capa": "Buscar capa...",
        "sin_resultados": "No se ha encontrado ninguna capa",
    },
    "paginacion": {
        "anterior": "Anterior",
        "siguiente": "Siguiente",
    },
    "sugerencias": {
        "campos": {
            "nombre": "Nombre",
            "apellidos": "Apellidos",
            "email": "Correo electrónico",
            "telefono": "Teléfono",
            "asunto": "Asunto",
            "mensaje": "Mensaje",
        },
        "enviar_sugerencia": "Enviar sugerencia",
        "enviado_sugerencia": "Enviando sugerencia...",
        "sugerencia_enviada_titulo": "Sugerencia enviada!",
        "sugerencia_error_titulo": "Error al enviar la sugerencia",
    },
    "catalogo": {
        "acceder_al_catalogo": "Acceder al catálogo",
        "descripcion": "Es posible acceder a la aplicación web del servicio de catálogo con el objetivo de realizar consultas y accesos a los servicios interoperables de información\n" +
            "geográfica desarrollados en las especificaciones del Open Geospatial Consortium (<a href=\"http://www.opengeospatial.org/\" target=\"_blank\">OGC</a>). El servicio de catálogo dispone de tecnología Geonode y \n" +
            "permite a los usuarios la localización de servicios web mediante búsquedas en la base de datos.",
        "direccion_servei": "Dirección de acceso al servicio",
        "descripcio_servei": "Descripción del servicio",
        "wms_titulo": "Servicio web de mapas – <b>WMS</b> - Visualización",
        "wms_descripcion": "El protocolo <b><a href=\"https://www.opengeospatial.org/standards/wms\" target=\"_blank\">WMS</a></b> es un servicio estándar definido " +
            "por el Open Geospatial Consortium (<b><a href=\"http://www.opengeospatial.org/\" target=\"_blank\">OGC</a></b>) con el objeto de producir mapas de forma " +
            "dinámica a partir de información geográfica. Este estándar define un \"mapa\" como una representación de la información geográfica en forma " +
            "de un archivo de imagen digital. Los mapas producidos por WMS  se generan normalmente en un formato de imagen como PNG o JPEG y pueden ser invocados por " +
            "cualquier protocolo web o software capacitado para la visualización de estos tipos de servicios.",
        "csw_titulo": "Servicio de catálogo – <b>CSW</b> - Consulta",
        "csw_descripcion": "El servicio Catalog Service for the Web (<b><a href=\"https://www.opengeospatial.org/standards/cat\" target=\"_blank\">CSW</a></b>)  es un " +
            "estándar definido por el Open Geospatial Consortium (<b>OGC</b>) con el objetivo de definir las interfaces para la recuperación, captura y consulta de " +
            "metadatos sobre los mismos datos. Permite la búsqueda de información geográfica de diferentes orígenes y temática variada de forma que el usuario pueda " +
            "localizar información geográfica utilizando las operaciones habilitadas a tal efecto.",
        "wfs_titulo": "Servicio de catálogo – <b>WFS</b> - Descarga",
        "wfs_descripcion": "El servicio Web Feature Service (<b><a href=\"https://www.opengeospatial.org/standards/wfs\" target=\"_blank\">WFS</a></b>) está definido " +
            "por el Open Geospatial Consortium (<b>OGC</b>) con el objeto de proporcionar la información relativa a la entidad almacenada en una cobertura vectorial " +
            "que reúnen las características formuladas en la consulta. Es un servicio estándar, que ofrece una interfaz de comunicación que permite " +
            "interactuar en los mapas servidos por el estándar <b>WMS</b>, como por ejemplo, editar la imagen que nos ofrece el servicio <b>WMS</b> o analizar la imagen " +
            "siguiendo criterios geográficos. El ayuntamiento de Vinaròs implementa este servicio mediante GeoServer.",
        "catalogo_desactivado": "Temporalmente están deshabilitados los servicios del catálogo. No obstante puedes ponerte en contacto con nosotros a través del formulario de sugerencia o de info@sigogestion.com. Si necesitas que te facilitemos alguna capa o acceso al servicio. En breve volverás a estar operativos. Disculpa las molestias.",
    }
}

